import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = ({customSize=null, ...props}: any) => (
  <CircularProgress {...props} color='secondary' size={customSize || 40} />
);

export default LoadingIndicator;